<template>
    <div>
        <v-tooltip bottom>
            <v-btn slot="activator"

                    icon
                    small
                    flat
                    @click="getDacte(nota.item._id)"
                    >
                    <v-icon class="material-icons">remove_red_eye</v-icon>
                </v-btn>
            <span>Visualizar DACTE</span>
         </v-tooltip>
                    <v-dialog @keydown.esc="dialog = false"
                    v-model="dialog"

                    fullscreen
                    :lazy="true"
                    >
                        <v-card>
                            <v-card-title
                            class="headline darkBlue text-xs-center"
                            text-color="white"
                            style="color: white;"

                            >
                            DACTE
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click.native="dialog = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                            </v-card-title>

                            <v-card-text id="tst">
                                <iframe style="width: 100%; height: 90vh;" :src="'data:application/pdf;base64,'+encodeURIComponent(this.nota.item.danfe)" frameborder="0"/>

                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="primary"
                                flat
                                @click="dialog = false"
                            >
                                Fechar
                            </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
    </div>

</template>
<script>
import CteService from "@/domain/notas/cte/CteService";
export default {
  props: ["nota"],
  data() {
    return {
      dialog: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    getDacte: async function(id) {
      if (!this.nota.item.danfe) {
        this.service = new CteService(this.$http);
        await this.service
          .getDacte(id)
          .then(danfe => (this.nota.item.danfe = danfe));
      }

      if (this.nota.item.danfe != null) {
        this.dialog = true;
      }
    }
  }
};
</script>
<style>

#lista {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_actions/btnVisualizar/btnCTe/BtnCTe.vue